import { render, staticRenderFns } from "./lemma-translation.vue?vue&type=template&id=36e8e46c&"
import script from "./lemma-translation.vue?vue&type=script&lang=js&"
export * from "./lemma-translation.vue?vue&type=script&lang=js&"
import style0 from "./lemma-translation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('36e8e46c', component.options)
    } else {
      api.reload('36e8e46c', component.options)
    }
    module.hot.accept("./lemma-translation.vue?vue&type=template&id=36e8e46c&", function () {
      api.rerender('36e8e46c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/lemma-translation.vue"
export default component.exports